(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-final-cta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (n) => String(n).padStart(2, '0');
    const parse = (t) => {
      const m = /^(\d{1,2}):(\d{1,2}):(\d{1,2})$/.exec((t || '').trim());
      return m ? (+m[1]) * 3600 + (+m[2]) * 60 + (+m[3]) : 5549;
    };
    const init = (scope = document) => {
      scope.querySelectorAll('[data-sm-final-timer]').forEach((root) => {
        if (root.dataset.ready) return;
        root.dataset.ready = 'true';
        const h = root.querySelector('[data-h]');
        const m = root.querySelector('[data-m]');
        const s = root.querySelector('[data-s]');
        let left;

        if (root.dataset.mode === 'date') {
          const end = Date.parse(root.dataset.end);
          if (!end) return;
          left = () => Math.max(0, Math.floor((end - Date.now()) / 1000));
        } else {
          const total = Math.max(1, parse(root.dataset.start));
          const key = 'sm-final-timer:' + root.dataset.key + ':' + total;
          let started = Date.now();
          try {
            const saved = Number(localStorage.getItem(key));
            if (saved > 0 && saved <= started) started = saved;
            else localStorage.setItem(key, String(started));
          } catch (e) {}
          left = () => {
            const elapsed = Math.floor((Date.now() - started) / 1000) % total;
            return total - elapsed;
          };
        }

        const render = () => {
          const t = left();
          if (root.dataset.mode === 'date' && t <= 0) { root.hidden = true; return false; }
          h.textContent = pad(Math.floor(t / 3600));
          m.textContent = pad(Math.floor((t % 3600) / 60));
          s.textContent = pad(t % 60);
          return true;
        };
        if (!render()) return;
        const timer = setInterval(() => {
          if (!root.isConnected || !render()) clearInterval(timer);
        }, 1000);
      });
    };
    init();
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-main-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!customElements.get('sm-gallery')) {
        class SmGallery extends HTMLElement {
          connectedCallback() {
            this.stage = this.querySelector('[data-stage]');
            if (!this.stage) return;
            this.slides = Array.from(this.stage.children);
            this.thumbs = Array.from(this.querySelectorAll('[data-go]'));
            this.zoomBtn = this.querySelector('[data-zoom-open]');
            this.dialog = this.querySelector('.sm-zoom');
            this.zoomImg = this.querySelector('[data-zoom-img]');
            this.index = 0;
            this.locked = false;
            this.thumbs.forEach((t) => t.addEventListener('click', () => this.go(Number(t.dataset.go))));
            let raf;
            this.stage.addEventListener('scroll', () => {
              if (this.locked) return;
              cancelAnimationFrame(raf);
              raf = requestAnimationFrame(() => this.sync());
            }, { passive: true });
            this.stage.addEventListener('keydown', (e) => {
              if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
              if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
            });
            this.zoomBtn?.addEventListener('click', () => this.openZoom());
            this.stage.addEventListener('click', (e) => {
              if (e.target.closest('[data-zoom] img') && window.matchMedia('(hover: hover)').matches) this.openZoom();
            });
            this.dialog?.addEventListener('click', (e) => {
              if (e.target === this.dialog || e.target.closest('[data-zoom-close]')) this.dialog.close();
            });
            this.mark(0);
          }
          sync() {
            const s = this.stage;
            if (s.scrollLeft + s.clientWidth >= s.scrollWidth - 4) return this.mark(this.slides.length - 1);
            const base = this.slides[0].offsetLeft;
            let best = 0;
            let min = Infinity;
            this.slides.forEach((slide, i) => {
              const d = Math.abs(slide.offsetLeft - base - s.scrollLeft);
              if (d < min) { min = d; best = i; }
            });
            this.mark(best);
          }
          mark(i) {
            if (i === this.index && this.initialised) return;
            this.initialised = true;
            this.index = i;
            this.thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i ? 'true' : 'false'));
            if (this.zoomBtn) this.zoomBtn.hidden = !this.slides[i]?.dataset.zoom;
            this.slides.forEach((slide, n) => {
              if (n !== i) slide.querySelectorAll('video').forEach((v) => v.pause());
            });
          }
          go(i) {
            const n = (i + this.slides.length) % this.slides.length;
            const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            this.locked = true;
            clearTimeout(this.lockTimer);
            this.lockTimer = setTimeout(() => { this.locked = false; }, 600);
            this.stage.scrollTo({ left: this.slides[n].offsetLeft - this.slides[0].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
            this.mark(n);
          }
          openZoom() {
            const slide = this.slides[this.index];
            if (!slide?.dataset.zoom || !this.dialog) return;
            this.zoomImg.src = slide.dataset.zoom;
            this.zoomImg.alt = slide.dataset.alt || '';
            this.dialog.showModal();
          }
        }
        customElements.define('sm-gallery', SmGallery);
      }
    // Display a rolling, always-visible timer. The display starts at 14:52:17
    // and returns to that value every 2 hours (these are independent values).
    // localStorage keeps the cycle consistent across refreshes and page visits.
    const initUrgencyCountdowns = (scope = document) => {
      scope.querySelectorAll('[data-sm-urgency]').forEach((root) => {
        if (root.dataset.countdownReady === 'true') return;
        const output = root.querySelector('[data-sm-urgency-time]');
        if (!output) return;
        const timeText = root.dataset.initialTime || '14:52:17';
        const matched = /^(\d{1,2}):(\d{2}):(\d{2})$/.exec(timeText);
        const initialSeconds = matched
          ? Number(matched[1]) * 3600 + Number(matched[2]) * 60 + Number(matched[3])
          : 14 * 3600 + 52 * 60 + 17;
        const resetHours = Math.max(1, Number(root.dataset.resetHours) || 2);
        const resetMs = resetHours * 60 * 60 * 1000;
        const storageKey = `sm-urgency-cycle:${location.pathname}:${root.dataset.smCycleId || 'default'}`;
        const now = Date.now();
        let startedAt = now;
        try {
          const stored = Number(localStorage.getItem(storageKey));
          if (stored > 0 && stored <= now) {
            startedAt = stored;
          } else {
            localStorage.setItem(storageKey, String(now));
          }
        } catch (e) {
          // Storage unavailable (e.g. private mode): still display and run the timer.
        }
        root.dataset.countdownReady = 'true';
        const display = () => {
          const elapsedSeconds = Math.floor((((Date.now() - startedAt) % resetMs) + resetMs) % resetMs / 1000);
          const secondsLeft = Math.max(0, initialSeconds - elapsedSeconds);
          const h = Math.floor(secondsLeft / 3600);
          const m = Math.floor((secondsLeft % 3600) / 60);
          const s = secondsLeft % 60;
          output.textContent = [h, m, s].map((part) => String(part).padStart(2, '0')).join(':');
        };
        display();
        const timer = setInterval(() => {
          if (!root.isConnected) { clearInterval(timer); return; }
          display();
        }, 1000);
      });
    };
    initUrgencyCountdowns();
    document.addEventListener('shopify:section:load', (event) => initUrgencyCountdowns(event.target));

    /* Review blocks: "Read more" only appears when the text is actually cut off */
    const initReviews = (scope = document) => {
      scope.querySelectorAll('.sm-review').forEach((card) => {
        if (card.dataset.reviewReady === 'true') return;
        const text = card.querySelector('[data-review-text]');
        const btn = card.querySelector('[data-review-more]');
        if (!text || !btn) return;
        card.dataset.reviewReady = 'true';
        const check = () => {
          if (text.classList.contains('is-expanded')) return;
          const clamped = text.scrollHeight > text.clientHeight + 1;
          text.classList.toggle('is-clamped', clamped);
          btn.hidden = !clamped;
        };
        check();
        if ('ResizeObserver' in window) new ResizeObserver(check).observe(text);
        btn.addEventListener('click', () => {
          const open = text.classList.toggle('is-expanded');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          btn.textContent = open ? btn.dataset.lessLabel : btn.dataset.moreLabel;
          if (!open) check();
        });
      });
    };
    initReviews();
    document.addEventListener('shopify:section:load', (event) => initReviews(event.target));

    /* Variant select -> price, compare, save, button state */
    document.addEventListener('change', (e) => {
      const select = e.target.closest('[data-sm-variant]');
      if (!select) return;
      const root = select.closest('[data-sm-pdp]');
      const d = select.selectedOptions[0].dataset;
      const onSale = d.onSale === 'true';
      const available = d.available === 'true';
      // :not(option) — the <option> elements carry the same data-* attributes.
      root.querySelectorAll('[data-price]:not(option)').forEach((el) => { el.textContent = d.price; });
      root.querySelectorAll('[data-compare]:not(option)').forEach((el) => {
        if (el.tagName === 'S') el.textContent = d.compare;
        el.hidden = !onSale;
      });
      root.querySelectorAll('[data-save]:not(option)').forEach((el) => { el.hidden = !onSale; });
      root.querySelectorAll('[data-save-amount]').forEach((el) => { el.textContent = d.save; });
      root.querySelectorAll('[data-save-percent]:not(option)').forEach((el) => { el.textContent = d.savePercent; });
      const btn = root.querySelector('button[name="add"]');
      if (btn) {
        btn.disabled = !available;
        const label = btn.querySelector('span');
        if (label) label.textContent = available ? btn.dataset.label : btn.dataset.soldOut;
      }
      document.dispatchEvent(new CustomEvent('sm:variant-change', {
        detail: { sectionId: root.dataset.smPdp, variantId: select.value, price: d.price, available }
      }));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
